import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import CircleLoader from "react-spinners/CircleLoader";
import parse from "html-react-parser";
import baseUrl from "../../url/baseUrl";
import "./DetailNews.css";

const DetailNews = () => {
  const { id } = useParams();

  const [news, setNews] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const getDetailNew = async () => {
      try {
        const response = await fetch(`${baseUrl}/news/${id}`);
        if (response.status !== 200) {
          throw new Error("Cannot fetch news from server");
        }
        const data = await response.json();

        setNews(data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
    };
    getDetailNew();
  }, []);

  return (
    <div className="detail_news">
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/news">News</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {news.title}
          </li>
        </ol>
      </nav>

      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <CircleLoader color="#36d7b7" size={50} />
        </div>
      )}

      {news && (
        <div className="detail_news_content mt-3" style={{ margin: "0 auto" }}>
          {/* <small>Published {new Date(news.createdAt).toLocaleString()}</small> */}
          <h3 className="mt-3">{news.title}</h3>
          <div className="news_content">{parse(news.content)}</div>
        </div>
      )}
    </div>
  );
};

export default DetailNews;
